import React, {useEffect, useState} from "react";
import axios from "axios";

interface Data {
    student_uid: string;
    username: string;
    nric: string;
}

const DataTest: React.FC = () => {
    const [data, setData] = useState<Data[]>([]);

    useEffect(() => {
        // const dbUrl = process.env.REACT_APP_BFF_URL;
        // if (!dbUrl) {
        //     console.error('Database URL not found in environment variables.');
        //     return;
        // }
        //axios.get<Data[]>(`${dbUrl}/api/admin`)
        axios.get<Data[]>('/api/admin')
            .then(response => {
                setData(response.data);
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }, []);

    return (
        <div className="DataTest">
            <h1>Data from BFF Node JSON</h1>
            <ul>
                {data.map(item => (
                    <li key={item.student_uid}>
                        <strong>{item.username}</strong> - <strong>{item.student_uid}</strong>
                    </li>
                ))}
            </ul>
        </div>
    );
};


export default DataTest;